import { useCopyToken } from '../../../hooks/useCopyToken';

const CopyTokenButton = () => {
  const { copyToken, showSuccess, showError, accessToken, isAccountAllowed } = useCopyToken();

  const isMockToken = accessToken === 'valid-mocked-oauth-bogus-token';

  // Se a conta não está autorizada, não renderiza o botão
  if (!isAccountAllowed) {
    return null;
  }

  return (
    <div className="relative">
      <button
        className="btn btn-default"
        onClick={copyToken}
        title={isMockToken ? "Token mock ativo - Use OAuth real" : "Copiar Access Token"}
      >
        <span className="rioglyph rioglyph-copy !m-[0] mr-1"></span>
        Token
      </button>
      {showSuccess && (
        <div className="absolute top-[-40px] left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-3 py-2 rounded shadow-lg whitespace-nowrap z-50">
          Token copiado com sucesso!
        </div>
      )}
      {showError && (
        <div className="absolute top-[-40px] left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-3 py-2 rounded shadow-lg whitespace-nowrap z-50">
          {isMockToken ? "Token mock - Desabilite mockAuthorization" : "Erro ao copiar token"}
        </div>
      )}
    </div>
  );
};

export default CopyTokenButton;
